export const IMPORT_CLIENTS = {
  errors: {
    codeIsNotUnique: 'Le code n\'est pas unique',
    enseigneIdOnEnseigne: 'Code Enseigne sur une ligne enseigne',
    enseigneIdOnGroupe: 'Code Enseigne sur une ligne groupe',
    enseigneIdNotInFile: 'Le code de l\'enseigne n\'est pas renseigné dans le fichier',
    groupeIdOnPdv: 'Code Groupe sur une ligne point de vente',
    groupeIdOnGroupe: 'Code Groupe sur une ligne point de groupe',
    groupeIdNotInFile: 'Le code du groupe n\'est pas renseigné dans le fichier',
    adresseFacturationIncomplete: 'L\'adresse de facturation n\'est pas complète',
    adressePostaleIncomplete: 'L\'adresse de postale n\'est pas complète',
    requiredPropertie: 'Le champ {label} est obligatoire',
    maxLengthPropertie: 'Le champ {label} est trop long: (taille max: {length})',
    marksMustBeEnclusedInQuotesAndSeparatedByCommas: 'Les marques doivent être entre des guillemets et séparées uniquement par des virgules',
    marksCannotBeDuplicated: 'Les marques ne peuvent pas être dupliquées pour un même client.',
  },
  ligneTotal: 'Il y a {errors} erreurs sur {total} lignes',
};

export const IMPORT_COMMANDES = {
  errors: {
    hasNoLignes: 'La commande n\'a pas de lignes de commande',
    requiredPropertie: 'Le champ {label} est obligatoire',
    maxLengthPropertie: 'Le champ {label} est trop long: (taille max: {length})',
    notFoundPropertie: 'Le champ {label} n\'existe pas',
    lignesError: 'Ligne Commande {num} : {error}',
    clientNotFound: 'Le client {name} n\'existe pas',
    montantError: 'Le montant HT de la commande n\'est pas cohérent avec ses lignes',
    echeancierPaiement: 'Problème de génération de l\'échéancier de paiement',
  },
  ligneTotal: 'Il y a {errors} erreurs sur {total} lignes',
};

export const IMPORT_COMMANDES_GENERALE = {
  errors: {
    hasNoLignes: 'La commande n\'a pas de lignes de commande',
    hasNoIntervenants: 'La commande n\'a pas d\'intervenants',
    intervenantDouble: 'La commande a un intervenant en double',
    totalTtc: 'Le total TTC de la commande n\'est pas cohérent avec les autres informations',
    requiredPropertie: 'Le champ {label} est obligatoire',
    maxLengthPropertie: 'Le champ {label} est trop long: (taille max: {length})',
    notFoundPropertie: 'Le champ {label} n\'existe pas',
    lignesError: 'Ligne Commande {num} : {error}',
    montantError: 'Le montant HT de la commande n\'est pas cohérent avec ses lignes',
    sumQuotePart: 'La répartition des intervenant n\'est pas égale a 100%',
    basicCalcul: 'Le montant brut {type} n\'est pas cohérent avec les autres informations (ligne commande n°{ligne})',
    basicCalculInformations: 'Les informations de calcul du montant brut de la ligne {type} ne sont pas du bon format (ligne commande n°{ligne})',
    netCalcul: 'Le montant net {type} n\'est pas cohérent avec les autres informations (ligne commande n°{ligne})',
    netCalculInformations: 'Les informations de calcul du montant net de la ligne {type} ne sont pas du bon format (ligne commande n°{ligne})',
    montantSmaller: 'Montant de la première échéances est plus grand que le montant de la ligne {type} (ligne commande n°{ligne})',
    tooMuchIntervenants: 'Trop d\'intervenants avec une repartition pour le role de la commande',
    reconductionWithOutRenouvelable: 'Reconductible sans être renouvelable',
    datePreavisSansRenouvelable: 'Date de préavis sans être renouvelable',
    dateRenouvellementSansRenouvelable: 'Date de renouvellement sans être renouvelable',
  },
  assistant: 'Assistant',
  commercial: 'Commercial',
  agence: 'Agence',
  intervenant: 'Client',
  role: 'Role',
  ligneTotal: 'Il y a {errors} erreurs sur {total} lignes',
};

export const IMPORT_CONTACTS = {
  errors: {
    clientNotFound: 'Le client {name} n\'existe pas',
    adresseIncomplete: 'L\'adresse  n\'est pas complète',
    requiredPropertie: 'Le champ {label} est obligatoire',
    maxLengthPropertie: 'Le champ {label} est trop long: (taille max: {length})',
    formatSiteWebIncorrect: 'Le format du site web saisi est incorrect.',
    contactTypeMustBeEnclusedInQuotesAndSeparatedByCommas: 'Les types de contact doivent être entre des guillemets et séparées uniquement par des virgules',
  },
  ligneTotal: 'Il y a {errors} erreurs sur {total} lignes',
};

export const IMPORT_CONTACTS_TIERS = {
  errors: {
    clientNotFound: 'Le client {name} n\'existe pas',
    contactNotFound: 'Le contact {name} n\'existe pas',
    requiredPropertie: 'Le champ {label} est obligatoire',
    maxLengthPropertie: 'Le champ {label} est trop long: (taille max: {length})',
  },
  ligneTotal: 'Il y a {errors} erreurs sur {total} lignes',
};

export const IMPORT_CAMPAGNES = {
  errors: {
    marqueNotFound: 'La marque {name} n\'existe pas',
    requiredPropertie: 'Le champ {label} est obligatoire',
    maxLengthPropertie: 'Le champ {label} est trop long: (taille max: {length})',
    tagMustBeEnclusedInQuotesAndSeparatedByCommas: 'Les tags doivent être entre des guillemets et séparées uniquement par des virgules',
    dateDebutGreaterDateFin: 'La date de début est plus grande que la date de fin pour la campagne {libelle}',
    wrongFormatDateDebut: 'La date de début doit être au a format texte',
    wrongFormatDateFin: 'La date de fin doit être au format texte',
  },
  ligneTotal: 'Il y a {errors} erreurs sur {total} lignes',
};

export const IMPORT_DEMANDES_IMPRESSION = {
  errors: {
    clientNotFound: 'Le client {name} n\'existe pas',
    campagneNotFound: 'La campagne {name} n\'existe pas',
    dispositifNotFound: 'Le dispositif {name} n\'existe pas',
    requiredPropertie: 'Le champ {label} est obligatoire',
    maxLengthPropertie: 'Le champ {label} est trop long: (taille max: {length})',
    clientDoNotMach: 'Le client {name} ne correspond pas à celui sur l\'emplacement du dispositif',
  },
  ligneTotal: 'Il y a {errors} erreurs sur {total} lignes',
};

export const IMPORT_BON_STOCK = {
  errors: {
    clientNotFound: 'Le client avec la référence externe {reference} n\'existe pas',
    requiredPropertie: 'Le champ {label} est obligatoire',
    clientIsNotLieuDeStockage: 'Le client avec la référence externe {reference} n\'est pas un lieu de stockage',
    noDefaultProductForVenteStock: 'La société n\'a pas de produit vente stock par défaut',
    noDefaultProductForAchatStock: 'La société n\'a pas de produit achat stock par défaut',
  },
};

export const IMPORT_LOGO_DISPOSITIF = {
  errors: {
    requiredPropertie: 'Le champ {label} est obligatoire',
    dispositifNotFound: 'Le dispositif avec le code {code} n\'existe pas',
  },
};
